import { type CompareBy } from '#src/types';

export const COMPARE_BY_KEYS: Record<
  CompareBy[number],
  'sublevelId' | 'subcategoryId' | 'fundingSourceId'
> = {
  level: 'sublevelId',
  category: 'subcategoryId',
  fundingSource: 'fundingSourceId',
};
